import React from "react";

function RequestTable(props) {
  return (
    <table className="table-layers-results table-spaces">
      <thead>
        <tr>
          <th className="table-column-name no-select">No.</th>
          <th className="table-column-name no-select">Solicitante</th>
          <th className="table-column-name no-select">Fecha Evento</th>
          <th className="table-column-name no-select">Tipo Solicitud</th>
          <th className="table-column-name no-select">Estado Solicitud</th>
          <th className="table-column-name no-select">Acciones</th>
        </tr>
      </thead>
      <tbody>
        {props.list.map((item) => (
          <tr key={"row-table-hg-ash-" + item.id}>
            <td className="table-column-user no-select">{item.rad}</td>
            <td className="table-column-user">{item.citizen ? item.citizen.name : ''}</td>
            <td className="table-column-user">{item.date ? item.date.split('T')[0] : ''}</td>
            <td className="table-column-user">{item.refRequestType ? item.refRequestType.name : ''}</td>
            <td className="table-column-user">{item.refRequestState ? item.refRequestState.name : ''}</td>
            <td className="table-column-user no-select pointer" >
              <div className="flex-center">
                <div onClick={() => props.go(`/ep/resolve/${item.id}`)} className={'kml-input-form-bottons primary-background-color on-mouse-hover'} title={'Descargar Código QR: ' + item.qr}>
                  <i className="fas fa-file"></i>
                </div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default RequestTable;
